import { Injectable } from '@angular/core';
import { PaymentDataUpdate } from '../../dtos/payment-type/payment-data-update';
import { PaymentData } from '../../interfaces/payment/payment-data';

@Injectable({
  providedIn: 'root',
})
export class PaymentTypeToPaymentTypeUpdateDtoMapperService {

  public map(paymentType: PaymentData): PaymentDataUpdate {
    return {
      id: paymentType.id,
      tenantId: paymentType.tenantId,
      paymentMethod: paymentType.paymentMethod,
      title: paymentType.title,
      status: paymentType.status,
      active: paymentType.active,
      activeSince: paymentType.activeSince,
      accountHolder: paymentType.accountHolder,
      IBAN: paymentType.IBAN,
      BIC: paymentType.BIC,
      bank: paymentType.bank,
      pspMerchantId: paymentType.pspMerchantId,
      emailNotification: paymentType.emailNotification,
      emailAddress: paymentType.emailAddress,
      vuNumber: paymentType.vuNumber,
      acquirer: paymentType.acquirer,
      provider: paymentType.acquirer,
      authorizationEnabled: paymentType.authorizationEnabled,
      refundsEnabled: paymentType.refundsEnabled,
      apiClientKey: paymentType.apiClientKey,
      apiClientSecret: paymentType.apiClientSecret,
      webhookKey: paymentType.webhookKey,
      webhookSecret: paymentType.webhookSecret,
      payPalEmailAddress: paymentType.payPalEmailAddress,
      payPalMerchantId: paymentType.payPalMerchantId,
      googlePayMerchantId: paymentType.googlePayMerchantId,
      payOnePartnerId: paymentType.payOnePartnerId,
      isChargebackCard: paymentType.isChargebackCard,
      chargebackProjectId: paymentType.chargebackProjectId,
      creditEnabled: paymentType.creditEnabled,
    }
  }
}
